import { CartContextProvider } from "context/CartContext";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

ReactDOM.render(
  <CartContextProvider>
    <App />
  </CartContextProvider>,
  document.getElementById("root")
);

